import styled from "styled-components";

import { Heading, Section } from "@vinomofo/components";

import { ContentfulPageProps } from "../../templates/content-page";

const HeroText = styled(Section)`
  text-align: center;
  position: relative;
  padding-bottom: 40px;

  h1,
  h2 {
    position: relative;
  }

  h1 {
    margin-bottom: 20px;
  }
`;

const Title = ({ title }: { title: string }) => (
  <HeroText px={[0, "16.664%"]} py="60px">
    <Heading variant="xxl" fontSize={["60px", "85px"]} color="black" as="h1">
      {title}
    </Heading>
  </HeroText>
);

const TitleAndSubtitle = ({
  title,
  subTitle,
}: {
  title: string;
  subTitle: string;
}) => (
  <HeroText px={[0, "16.664%"]} py="60px">
    <Heading variant="xs" color="brand" as="h1">
      {title}
    </Heading>
    <Heading variant="xxl" fontSize={["60px", "85px"]} color="black" as="h2">
      {subTitle}
    </Heading>
  </HeroText>
);

export const LargeHeader = ({
  title,
  subTitle,
}: Pick<ContentfulPageProps, "title" | "subTitle">): JSX.Element => {
  return (
    <Section>
      {subTitle ? (
        <TitleAndSubtitle title={title} subTitle={subTitle} />
      ) : (
        <Title title={title} />
      )}
    </Section>
  );
};
